import { SET_KNOWN_FILES } from '../constants/ActionTypes'

/**
 * @typedef {import('../index').KnownFilesEntry} KnownFilesEntry
 * @typedef {import('../index').PltrAction} PltrAction
 */

/* e.g. state
 * [
 *   {
 *     "pathToContainingFolder": ["Users", "johndoe", "documents", "plottr-files"],
 *     "fileURL": "device:///Users/edwardsteere/Downloads/Untitled-Return-of-the-test.pltr",
 *     "lastOpened": 1636969518301,
 *     "fileName": "Untitled. Return of the Test.",
 *     "permission": "owner",
 *     "isOfflineBackup": false,
 *     "isBackupFile": false,
 *     "isTempFile": false
 *   },
 * ]
 */

/**
 * @type {Array<KnownFilesEntry>}
 */
const INITIAL_STATE = []

/**
 * @param {Array<KnownFilesEntry>} state
 * @param {PltrAction} action
 * @return {Array<KnownFilesEntry>}
 */
const knownFilesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_KNOWN_FILES: {
      return action.knownFiles
    }
    default: {
      return state
    }
  }
}

export default knownFilesReducer
